import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiPageComponent } from './eui-page.component';
import { EuiCommonHeaderModule, EuiExpandContentModule } from '../../shared';
import { EuiPageColumnComponent,
    EuiPageColumnHeaderBodyContentDirective,
    EuiPageColumnHeaderLeftContentDirective,
    EuiPageColumnHeaderRightContentDirective,
    EuiPageColumnHeaderCollapsedContentDirective,
    EuiPageColumnBodyContentDirective,
    EuiPageColumnFooterContentDirective } from './components/eui-page-column/eui-page-column.component';
import { EuiPageColumnsComponent } from './components/eui-page-columns/eui-page-columns.component';
import { EuiPageContentComponent } from './components/eui-page-content/eui-page-content.component';
import { EuiPageHeaderComponent,
    EuiPageHeaderActionItemsContentDirective,
    EuiPageBodyContentDirective } from './components/eui-page-header/eui-page-header.component';
import { EuiPageHeroHeaderComponent } from './components/eui-page-hero-header/eui-page-hero-header.component';
import { EuiPageFooterComponent } from './components/eui-page-footer/eui-page-footer.component';

import { EuiButtonModule } from '../../components/eui-button/eui-button.component';

import { UxOverlayComponentModule } from '@eui/components';

const COMPONENTS = [
    EuiPageComponent,
    EuiPageColumnComponent,
    EuiPageColumnHeaderBodyContentDirective,
    EuiPageColumnHeaderLeftContentDirective,
    EuiPageColumnHeaderRightContentDirective,
    EuiPageColumnHeaderCollapsedContentDirective,
    EuiPageColumnBodyContentDirective,
    EuiPageColumnFooterContentDirective,
    EuiPageColumnsComponent,
    EuiPageContentComponent,
    EuiPageHeaderComponent,
    EuiPageHeaderActionItemsContentDirective,
    EuiPageBodyContentDirective,
    EuiPageHeroHeaderComponent,
    EuiPageFooterComponent,
];

@NgModule({
    imports: [
        CommonModule,
        EuiCommonHeaderModule,
        EuiExpandContentModule,
        EuiButtonModule,
        UxOverlayComponentModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiPageModule { }
